import SearchMobileActions from '@ui/Search/MobileActions/component'
import dataLayer from 'assets/core/js/module/data-layer'
import ElementPropertiesManager from 'assets/core/js/module/element-properties-manager'
import type { MobileBottomPanelType } from '@ui/MobileBottomPanel/component'
import type SearchMapModal from '@ui/Search/Map/Modal/component'
import type { SearchMobileRecapType } from '@ui/Search/MobileRecap/component'

export default (): void => {
  const searchMobileRecapEl = document.getElementById('search-mobile-recap')
  const searchFiltersMobileBottomPanelEl = document.getElementById('search-filters-mobilebottompanel')
  const mapEl = document.getElementById('search-map-modal-container')

  let searchMobileRecap: SearchMobileRecapType | undefined
  let mobileBottomPanel: MobileBottomPanelType | undefined
  let searchMap: SearchMapModal | undefined

  const searchMobileActionsEl = document.getElementById('search-mobile-actions')
  searchMobileActionsEl &&
    SearchMobileActions(searchMobileActionsEl, {
      onClickSearchButton: () => {
        if (searchMobileRecapEl && !searchMobileRecap) {
          searchMobileRecap = ElementPropertiesManager.getProperty<SearchMobileRecapType>(searchMobileRecapEl, 'searchMobileRecap')
        }

        searchMobileRecap?.open()
      },
      onClickFilterButton: () => {
        if (searchFiltersMobileBottomPanelEl && !mobileBottomPanel) {
          mobileBottomPanel = ElementPropertiesManager.getProperty<MobileBottomPanelType>(searchFiltersMobileBottomPanelEl, 'mobileBottomPanel')
        }

        mobileBottomPanel?.open()

        dataLayer.pushInLayer(window.coreGtmId, {
          event: dataLayer.events.SEARCH_USE_FILTER,
          page_category: dataLayer.getPageCategory(window.coreGtmId) ?? '',
        })
      },
      onClickMapButton: () => {
        if (mapEl && !searchMap) {
          searchMap = ElementPropertiesManager.getProperty<SearchMapModal>(mapEl, 'searchMapModal')
        }

        searchMap?.open()
      },
    })
}
